// extracted by mini-css-extract-plugin
export default {"errorContainer":"CatalogItemsError_errorContainer__L17uy","contentError":"CatalogItemsError_contentError__j8Hjw","errorMessage":"CatalogItemsError_errorMessage__-2l28"};